import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { map } from 'rxjs'

import { environment } from '../../../../environments/environment'
import { ApiResponse } from '../../types/response.type'
import { Currency } from './types/drawer.type'

const API_URL = environment.apiUrl

@Injectable({
	providedIn: 'root',
})
export class DrawerService {
	constructor(private readonly httpClient: HttpClient) {}

	getCurrencyList() {
		return this.httpClient.get<ApiResponse<Currency[]>>(`${API_URL}/api/currency`).pipe(map((response) => response.result))
	}

	updateLanguage(payload: { LANGUAGE: string; session_id: string }) {
		return this.httpClient.post<ApiResponse<void[]>>(`${API_URL}/api/users/update_lang`, payload).pipe(map(() => payload.LANGUAGE))
	}
}
